<template>
  <div class="el-form-reduce">
    <span class="delete" @click="onDel">删除本条</span>
    <el-form :ref="refFrom" :model="model" :rules="rules" class="el-form-flex">
      <slot :form="model" />
    </el-form>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  props: {
    refFrom: {
      type: String,
      default: 'form'
    },
    model: {
      type: Object,
      default: () => {}
    },
    rules: {
      type: Object,
      default: () => {}
    },
    fixCon: {
      type: Object,
      default: null
    }
  },
  data() {
    return {

    }
  },
  methods: {
    ...mapMutations('resume', ['CHANGE_RESUME_CON']),
    onDel() {
      if (this.fixCon) {
        const { type, tem, idx } = this.fixCon
        this.CHANGE_RESUME_CON({
          type,
          tem,
          idx
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.el-form-reduce {
  position: relative;

  &:hover {

    .delete {
      display: block;
    }
  }

  .delete {
    display: none;
    position: absolute;
    right: 20px;
    top: 10px;
    cursor: pointer;
    color: #ff5265;
    line-height: 22px;
  }
}
</style>

